<script setup lang="ts">
import { onMounted, ref } from 'vue';
import Splide from '@splidejs/splide';

const splideEl = ref<HTMLElement | null>(null);
const clientReviews: any = await useAcfOptions('client_reviews');

onMounted(() => {
    if (splideEl.value) {
        const splide = new Splide(splideEl.value, {  
            perPage: 3,
            rewind : true,
            type: 'loop',
            gap: '1rem',
            pagination: false,
            // arrows: false
            breakpoints: {
              998: {
                arrows: false,
                perPage: 1,
                pagination: false,
                padding: { left: '0rem', right: '4rem' },
                gap: '0rem'
              }
            }
        });
    
        splide.mount();
    }
});
</script>

<template>
  <div class="container-xl px-0 client-reviews-div">
    <div v-if="clientReviews?.length" class="splide custom-splide" ref="splideEl">
      <div class="splide__arrows">
        <button class="splide__arrow splide__arrow--prev">
          <NuxtImg loading="lazy"
            alt="Previous"
            quality="80"
            height="50" width="50"
            src="/left-light-arrow.svg"/>
        </button>
        <button class="splide__arrow splide__arrow--next">
          <NuxtImg loading="lazy"
            alt="Next"
            quality="80"
            height="50" width="50"
            src="/right-light-arrow.svg"/>
        </button>
      </div>
      <div class="splide__track">
        <ul class="splide__list">
          <li
            v-for="(review,n) in clientReviews"
            class="splide__slide"
          >
            <div class="slide-wrapper reviews py-4 px-3">
                <div class="card justify-content-between">
                    <div class="heading d-flex flex-column">
                        <div class="d-flex">
                            <div class="circle"></div>
                            <div class="title ps-3 d-flex flex-column">
                                <span class="text-primary">{{ review.name }}</span>
                                <span class="text-green-light">{{ review.date }}</span>
                            </div>
                        </div>
                        <div class="stars">
                          <span v-for="i in parseInt(review.rating)">★</span>
                        </div>
                    </div>
                    <div>
                        <p>{{ review.message }}</p>
                    </div>
                    <div class="d-flex justify-content-between with-hover">
                        <a aria-label="Read More" :href="review.link" class="d-flex align-items-center hover-head-shake">
                          <span class="text-dark-2 me-3">Read More</span> 
                          <NuxtImg :alt="`Read More Review ${n}`" height="15" width="15" loading="lazy" src="/right-dark-arrow.svg"/>
                        </a>
                        <NuxtImg class="logo-img" :alt="`Google Review ${n}`" loading="lazy" width="30" height="30" src="/google.png"/>
                    </div>
                </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>